module.exports = __webpack_public_path__ + "static/media/antion.19f19cce.svg";